import { createSlice } from '@reduxjs/toolkit';
import { MenuOption, MenuOptionView } from './types';

const NAME = 'analyzer';

// * Reducer
export interface State {
	selectedNew: MenuOption;
	selectedView: MenuOptionView;
}

export const initialState: State = {
	selectedNew: MenuOption['Create portfolio'],
	selectedView: MenuOptionView['Saved analysis'],
};

export const slice = createSlice({
	name: NAME,
	initialState,
	reducers: {
		setSelectedNew: (state, action: { payload: MenuOption }) => {
			state.selectedNew = action.payload;
		},
		setSelectedView: (state, action: { payload: MenuOptionView }) => {
			state.selectedView = action.payload;
		},
		clearAll: (state) => {
			state.selectedNew = initialState.selectedNew;
			state.selectedView = initialState.selectedView;
		},
	},
});

export const actionsAnalyzer = {
	...slice.actions,
};
